<div class="flex justify-between items-center flex-wrap gap-1 mb-1">
  <nz-radio-group [(ngModel)]="quickFilter" (ngModelChange)="filterData()" nzButtonStyle="outline">
    <label nz-radio-button nzValue="all" class="font-semibold radio-button-primary">
      <i nz-icon nzType="unordered-list" nzTheme="outline" class="mr-2"></i>
      All {{counts.total_count}}
    </label>
    <label nz-radio-button nzValue="active" class="font-semibold radio-button-success">
      <i nz-icon nzType="hezky:Gateway" nzTheme="outline" class="mr-2"></i>
      Active {{counts.active_count}}
    </label>
    <label nz-radio-button nzValue="inActive" class="font-semibold radio-button-warning">
      <span class="text-[9px] text-[#B7B7B7]">x</span>
      <i class="mr-2" style="font-size: 14px !important;color: rgb(176, 180, 180);" nz-icon
        [nzType]="'hezky:Signal'"></i>
      Inactive {{counts.inactive_count}}
    </label>
  </nz-radio-group>
  <nz-page-header-extra>
    <nz-space>
      <nz-input-group class="mr-1" [nzPrefix]="searchIcon">
        <input nz-input class="w-full" type="search" [(ngModel)]="searchText" placeholder="Search here..."
          (ngModelChange)="getSearchDetails(searchText)">
      </nz-input-group>
      <ng-template #searchIcon>
        <span nz-icon nzType="search" aria-hidden="true"></span>
      </ng-template>
      <button nz-button class="mr-1" nzType="default" type="button" [nzTooltipColor]="'#fff'" nz-tooltip
        nzTooltipTitle="Refresh" [nzShape]="'circle'" (click)="refreshHandler()">
        <i nz-icon nzType="reload"></i>
      </button>
      <button nz-button class="mr-1" [nzType]="'primary'" nzSize="default" (click)="showModal('excel')"><i nz-icon
          nzType="plus"></i>Add Excel</button>
      <button nz-button class="mr-1" [nzType]="'primary'" nzSize="default" (click)="showModal('gateway')"><i nz-icon
          nzType="plus"></i>Add Gateway</button>
    </nz-space>
  </nz-page-header-extra>
</div>

<nz-table #gatewayTable nzShowSizeChanger [nzLoading]="this.apiCallLoaders['isGatewaysLoading']"
  [nzScroll]="{ x: '1024px', y: '35dvh' }" [nzSize]="'small'" [nzPaginationType]="'small'" [nzShowTotal]="totalTemplate"
  [nzData]="filteredGatewayList$">
  <thead>
    <tr>
      <th nzEllipsis="...">Status</th>
      <th nzEllipsis="...">Name</th>
      <th nzEllipsis="...">Serial Number</th>
      <th nzEllipsis="...">Location</th>
      <th nzEllipsis="...">Location ID</th>
      <th nzEllipsis="...">Last Updated</th>
      <th nzEllipsis="...">Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let gateway of gatewayTable.data; let i = index; trackBy: commonService.trackByFn">
      <td nzEllipsis="...">
        <button nzType="default" class="text-[#fff] px-2 py-1 rounded-lg"
          [ngClass]="{'bg-[#008001]' : gateway?.is_active, 'bg-danger'  : !gateway?.is_active}">
          <span *ngIf="gateway?.is_active" class="mr-1" style="font-size: 14px !important" nz-icon
            [nzType]="'hezky:Gateway'"></span>
          {{ gateway?.is_active ? 'Online' : 'Offline' }}
        </button>
      </td>
      <td nzEllipsis="...">{{ gateway?.gateway_name }}</td>
      <td nzEllipsis="...">{{ gateway?.serial_no}}</td>
      <td nzEllipsis="...">{{ gateway?.display_name }}</td>
      <td nzEllipsis="...">{{ gateway?.location_id }}</td>
      <td nzEllipsis="...">{{ gateway?.last_update_date | date:'yyyy-MM-dd HH:mm:ss' }}</td>
      <td nzEllipsis="...">
        <span nz-tooltip="Edit" [nzTooltipColor]="'#fff'" nz-icon nzType="edit" nzTheme="outline"
          class="text-base text-primary cursor-pointer" (click)="editGateway(gateway)"></span>
        <span nz-tooltip="Delete" nz-icon nzType="delete" [nzTooltipColor]="'#fff'" nzTheme="outline"
          class="text-base text-danger cursor-pointer ml-5" nz-popconfirm nzPopconfirmPlacement="bottom"
          nzPopconfirmTitle="Are you sure to remove this record?"
          (nzOnConfirm)="deleteGateway(gateway.gateway_id)"></span>
      </td>
    </tr>
  </tbody>
</nz-table>

<nz-modal [(nzVisible)]="isExcelModalVisible" [nzTitle]="modalTitle" (nzOnCancel)="handleCancel('excel')"
  [nzWidth]="550">
  <ng-template #modalTitle>
    <div class="flex justify-between items-center">
      <span class="text-lg font-medium">Add Excel</span>
      <a *ngIf="excelErrLink" (click)="downloadLogFile()"
        class="text-blue-600 font-bold cursor-pointer hover:underline">
        <i nz-icon nzType="download" nzTheme="outline" class="mr-1"></i>
        Download Log
      </a>
    </div>
  </ng-template>

  <ng-template #excelContent>
    <ng-container>
      <div *ngIf="excelErr && !isSuccessMessage"
        class="mb-4 p-3 bg-red-50 text-red-700 border border-red-200 rounded-md">
        <strong>Error:</strong> {{ excelErr }}
      </div>

      <!-- Success Message -->
      <div *ngIf="excelErr && isSuccessMessage"
        class="mb-4 p-3 bg-green-50 text-green-700 border border-green-200 rounded-md">
        <strong>Success:</strong> {{ excelErr }}
      </div>

      <div *ngIf="!excelErrLink" class="mb-3 text-center flex justify-end">
        <a class="cursor-pointer hover:underline text-blue-600 font-bold" nz-popconfirm
          (nzOnConfirm)="downloadTemplate()" nzPopconfirmTitle="Are you sure to download this template file?"
          nzPopconfirmPlacement="bottom">
          <i nz-icon nzType="download" nzTheme="outline" class="mr-1"></i>
          Download Template
        </a>
      </div>
      <ng-container>
        <div
          class="upload-container border-2 border-dashed border-gray-300 bg-white p-6 rounded-lg mb-4 text-center hover:border-blue-400 transition-colors">
          <label for="excelFile" class="custom-file-upload w-full block cursor-pointer">
            <i nz-icon nzType="upload" nzTheme="outline" class="text-primary text-[32px] block mb-3"></i>
            <input #addAssetFile type="file" id="excelFile" (change)="onFileChange($event)" accept=".xls,.xlsx"
              class="hidden">
            <p class="ant-upload-text font-medium mb-2 text-base">Click or drag file to this area to upload</p>
            <p class="ant-upload-hint text-gray-500">File headers should match, and all fields must have
              appropriate data.</p>
          </label>
        </div>
        <div class="uploaded-files" *ngIf="fileList.length > 0">
          <h4 class="text-sm font-medium mb-3 text-gray-700 pl-1">Uploaded Files</h4>
          <div *ngFor="let file of fileList; let i = index"
            class="uploaded-file flex items-center justify-between p-3 mb-3 bg-white border border-gray-300 rounded-md hover:shadow-sm transition-shadow">
            <div class="flex items-center">
              <i nz-icon [nzType]="file.name.toLowerCase().endsWith('.xlsx') ? 'file-excel' : 'file-excel'"
                nzTheme="twotone" class="mr-3 text-lg"></i>
              <span class="filename font-medium">{{ file?.name }}</span>
            </div>
            <div class="flex items-center gap-3">
              <span class="filesize text-sm text-gray-600">
                {{ (file.size / 1024 / 1024).toFixed(2) }} MB
              </span>
              <button type="button" nz-button nzType="text" nzDanger (click)="removeFile(i)"
                class="flex items-center justify-center p-1 hover:bg-red-50 rounded-full">
                <i nz-icon nzType="delete"></i>
              </button>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-template>

  <ng-template #excelFooter>
    <div class="flex justify-end gap-3 pt-2">
      <button nz-button nzType="default" (click)="handleCancel('excel')" class="px-5 py-1 h-9">Cancel</button>
      <button nz-button nzType="primary" (click)="onExcelSubmit()" [nzLoading]="isConfirmLoading"
        class="px-5 py-1 h-9">Submit</button>
    </div>
  </ng-template>
  <ng-container *nzModalContent>
    <ng-container *ngTemplateOutlet="excelContent"></ng-container>
  </ng-container>
  <ng-container *nzModalFooter>
    <ng-container *ngTemplateOutlet="excelFooter"></ng-container>
  </ng-container>
</nz-modal>

<nz-modal [(nzVisible)]="isGatewayModalVisible" [nzTitle]="'Add New Gateway'" (nzOnCancel)="handleCancel('gateway')"
  [nzWidth]="600">

  <ng-template #gatewayContent>
    <form nz-form [formGroup]="form" [nzLayout]="'vertical'" role="form" aria-labelledby="form" class="p-4">
      <div class="space-y-4">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired nzFor="name" class="pb-1 text-base">Gateway Name</nz-form-label>
          <nz-form-control [nzSpan]="24" [nzErrorTip]="'Gateway Name is required'">
            <input nz-input formControlName="name" class="w-full py-2 px-3 rounded-md" maxlength="100"
              placeholder="Enter Gateway Name" />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired nzFor="location_id" class="pb-1 text-base">Location</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select nzMode="default" formControlName="location_id" nzPlaceHolder="Select Location" class="w-full"
              nzShowSearch nzShowArrow="false">
              <nz-option *ngFor="let location of locationOptions" [nzValue]="location.location_id"
                [nzLabel]="location.display_name">
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired nzFor="serialNo" class="pb-1 text-base">Gateway Serial
            No.</nz-form-label>
          <nz-form-control [nzSpan]="24" [nzErrorTip]="'Gateway Serial No is required'">
            <nz-select formControlName="serialNo" nzPlaceHolder="Select Gateway Serial No" nzShowSearch
              nzShowArrow="false" class="w-full">
              <nz-option *ngFor="let option of serialNoOptions" [nzValue]="option.serial_no"
                [nzLabel]="option.serial_no"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>

        <div class="flex items-center gap-3 mb-1 mt-3 bg-gray-50 p-3 rounded-md border border-gray-200">
          <nz-form-control [nzSpan]="24">
            <label nz-checkbox formControlName="enableAlarm" class="font-medium">Set Alarm</label>
          </nz-form-control>
        </div>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired nzFor="alarm" class="pb-1 text-base">Alarm Severity</nz-form-label>
          <nz-form-control [nzSpan]="24">
            <nz-select nzMode="default" formControlName="alarm" nzPlaceHolder="Select Alarm Severity" class="w-full"
              [nzDisabled]="!form.get('enableAlarm')?.value">
              <nz-option *ngFor="let option of severityOptions" [nzValue]="option.value"
                [nzLabel]="option.value"></nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </form>
  </ng-template>

  <ng-template #gatewayFooter>
    <div class="flex justify-end gap-3 pt-2">
      <button nz-button nzType="default" (click)="handleCancel('gateway')" class="px-5 py-1 h-9">Cancel</button>
      <button nz-button nzType="primary" (click)="onSubmit()" [nzLoading]="isConfirmLoading"
        class="px-5 py-1 h-9">Submit</button>
    </div>
  </ng-template>
  <ng-container *nzModalContent>
    <ng-container *ngTemplateOutlet="gatewayContent"></ng-container>
  </ng-container>
  <ng-container *nzModalFooter>
    <ng-container *ngTemplateOutlet="gatewayFooter"></ng-container>
  </ng-container>
</nz-modal>

<ng-template #totalTemplate let-total>Showing {{ total }} items</ng-template>